import { Box, Button, Tooltip } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { useCrossSectionDrawingHistory } from '~/hooks/undo/useCrossSectionDrawingHistory';
import { sdfOperationInFlightState } from '~/state/atoms/structureSet/roiAtoms';

/** The Cross-Section tool's options: Clear, which drops what is drawn. */
export default function CrossSectionToolOptions() {
    const intl = useIntl();
    const isProcessing = useRecoilValue(sdfOperationInFlightState);
    const { hasDrawing, clear } = useCrossSectionDrawingHistory();

    return (
        <Tooltip
            title={intl.formatMessage({ id: 'crossSectionTool.clear.hint' })}
        >
            {/* A disabled Button fires no events, so the tooltip needs a wrapper. */}
            <Box component="span" sx={{ display: 'flex', flex: '1 1 100%' }}>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    fullWidth
                    disabled={!hasDrawing || isProcessing}
                    onClick={clear}
                    data-testid="cross-section-clear"
                >
                    <FormattedMessage id="crossSectionTool.clear" />
                </Button>
            </Box>
        </Tooltip>
    );
}
